import { Box, Heading, Stack, Separator } from '@chakra-ui/react';

interface Props {
  block: {
    type: number;
    label: string;
  };
}

export default function SectionTitleBlock({ block }: Props) {
  return (
    <Box>
      <Stack w='full' gap={0}>
        <Heading as='h2' fontSize='xl'>
          {block.label}
        </Heading>
        <Separator size='md' mx={-3} />
      </Stack>
    </Box>
  );
}
